const error = response =>
  response.json().then(
    body =>
      Promise.reject(
        new Error({
          status: response.status,
          message: body,
        })
      ),
    () =>
      Promise.reject(
        new Error({
          status: response.status,
        })
      )
  )

export const fetchJson = (path, options) =>
  fetch(path, options).then(response => {
    if (response.status === 200 || response.status === 201) {
      return response.json()
    }
    return error(response)
  })

const fetchJsonNoError = (path, options) => fetch(path, options).then(response => response.json())

export const request = (path, method = 'GET', data, additionalHeader) => {
  const options = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }

  if (additionalHeader) {
    Object.keys(additionalHeader).forEach(key => {
      options.headers[key] = additionalHeader[key]
    })
  }

  if (data) {
    options.body = JSON.stringify(data)
  }
  return fetchJson(path, options)
}

export const authCall = (path, method = 'GET', noError) => {
  const options = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  }
  if (noError) return fetchJsonNoError(path, options)
  return fetchJson(path, options)
}

export const tokenCall = (token, path, method = 'GET', data) => {
  const options = {
    method,
    headers: {
      Accept: 'application/vnd.com.easybib.data+json',
      Authorization: `Bearer ${token}`,
    },
  }
  if (data) {
    options.body = JSON.stringify(data)
  }
  return fetchJson(path, options)
}
